import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  padding-top: 15px;
  width: 100%;
  padding-bottom: 15px;
`;

export default Container;
